<script>
import Layout from "@/views/layouts/main.vue";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import http from "@/services/http";
import appConfig from "@/app.config.json";
import store from '@/state/store';

export default {
  name: "waste.detail",
  page: {
    title: "廃棄物詳細",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      waste: {},
      isLoading: false,
      targetWorkType: [4, 5]
    };
  },
  components: {
    Layout,
    CommonTableComponent
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let url = '';
      if(this.wasteId){
        url = apiEndpoints.wastes_detail(this.wasteId);
      }else if(this.dailyReportId && this.dailyReportId != 0){
        url = apiEndpoints.wastes_detail_json(this.dailyReportId , this.wasteOrServiceId);
      }else{
        url = apiEndpoints.wastes_detail_by_wos_id(this.wasteOrServiceId);
      }
      const sendApiProject = await http.get(url, {});
      const { status, data } = sendApiProject;
      if (status) {
        this.waste = data.result;
      }

      this.isLoading = false;
    },
    getRecycle(code){
      return this.$constant.RECYCLE_TYPES[code];
    },
    backToList() {
      let query =
        localStorage.getItem("projects/sales/waste") == null
          ? {
              activeTabIndex: this.$constant.pages.project.sales.waste.tabIndex
            }
          : JSON.parse(localStorage.getItem("projects/sales/waste"));
      this.$router.push({
        name: "projects.sales",
        params: { id: this.projectId },
        query: query
      });
    },
    getActivate(estimate){
      return estimate.is_activate == "1" ? "受注" : "未受注";
    }
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    wasteId() {
      return this.$route.params.waste_id;
    },
    dailyReportId() {
      return this.$route.params.daily_report_id;
    },
    wasteOrServiceId() {
      return this.$route.params.id;
    },
    wasteCategoryMixedChecks() {
      //get data from waste, which key start with waste_category_mixed_check
      let wasteCategoryMixedCheck = [];
      for (let key in this.waste) {
        if (key.startsWith("waste_category_mixed_check")) {
          wasteCategoryMixedCheck.push(this.waste[key]);
        }
      }
      return wasteCategoryMixedCheck;
    },
    zzHazardousWasteCategoryChecks() {
      //get data from waste, which key start with zz_hazardous_waste_category_check
      let zzHazardousWasteCategoryCheck = [];
      for (let key in this.waste) {
        if (key.startsWith("zz_hazardous_waste_category_check")) {
          zzHazardousWasteCategoryCheck.push(this.waste[key]);
        }
      }
      return zzHazardousWasteCategoryCheck;
    },
    disposalSitesByWaste() {
      if (!Object.keys(this.waste).length) return [];
      if (!this.waste.disposal_sites) return [];

      return this.waste.disposal_sites;
    },
    estimates() {
      if (!Object.keys(this.waste).length) return [];

      return this.waste.estimates;
    },
    commentsByTreatmentGroup() {
      if (!Object.keys(this.waste).length) return [];

      return this.waste.comments_by_treatment_group;
    },
    isTreatmentGroup() {
      if (! store.getters['auth/user']) return false;
      if (!store.getters['auth/user']['department'] || !store.getters['auth/user']['department']['division']) return false;

      // console.log(store.getters['auth/user']['department']['zz_division_id']);

      // zz_division_id でログインユーザーが環境管理部かどうか判断
      return store.getters['auth/user']['department']['zz_division_id'] === this.$constant.DEPARTMENT['environmental_management_department'];
    }
  }
};
</script>
<template>
  <Layout>
    <b-container fluid>
      <div class="d-flex justify-content-end mb-2">
        <b-button variant="primary" size="lg" @click="backToList()">{{
          this.$lang.button.back
        }}</b-button>
      </div>
      <b-card :show="isLoading">
        <b-row>
          <div class="table-responsive">
            <table
              class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
            >
              <thead class="table-light">
                <tr>
                  <th>HK管理番号</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ waste.waste_cd }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">基本情報</div>
            <div class="table-responsive">
              <table
                class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                  <tr>
                    <th colspan="4">商流*</th>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <p v-if="waste.case">{{ waste.case.case_name }}</p>
                    </td>
                  </tr>
                  <tr>
                    <th>得意先</th>
                    <th>事業者</th>
                    <th>事業場</th>
                    <th>関係委託先</th>
                  </tr>
                  <tr>
                    <td>
                      <p v-if="waste.case">{{ waste.case.customer ? waste.case.customer.name_abbreviated : '' }}</p>
                    </td>
                    <td>
                      <p v-if="waste.case">{{ waste.case.discharger ? waste.case.discharger.name_abbreviated : '' }}</p>
                    </td>
                    <td>
                      <p v-if="waste.case">{{ waste.case.discharger_site ? waste.case.discharger_site.name_abbreviated : '' }}</p>
                    </td>
                    <td>
                      <p v-if="waste.case">{{ waste.case.vendor ? waste.case.vendor.name_abbreviated : '' }}</p>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="3">廃棄物種類</th>
                    <th>商品</th>
                  </tr>
                  <tr>
                    <td colspan="3">{{ waste.waste_category ? waste.waste_category.name_abbreviated : '' }}</td>
                    <td>
                      <p v-if="waste.waste_category && waste.waste_category.product">
                        {{ waste.waste_category.product.name_abbreviated }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="4">廃棄物名*</th>
                  </tr>
                  <tr>
                    <td colspan="4">{{waste.name}}</td>
                  </tr>
                  <tr>
                    <th colspan="4">対象作業種別</th>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <div v-for="(wasteCategoryMixedCheck, index) in wasteCategoryMixedChecks" :key="`waste_category_mixed_${index}`">
                          <p><b>{{`チェック用廃棄物種類${index + 1}`}}</b></p>
                          <p v-if="wasteCategoryMixedCheck">{{wasteCategoryMixedCheck.name_abbreviated}}</p>
                          <hr>
                      </div>
                    </td>
                    <td colspan="2">
                      <div v-for="(zzHazardousWasteCategoryCheck, index) in zzHazardousWasteCategoryChecks" :key="`zz_hazardous_waste_category_check_${index}`">
                        <p><b>{{`チェック用有害物質${index + 1}`}}</b></p>
                        <p v-if="zzHazardousWasteCategoryCheck">{{zzHazardousWasteCategoryCheck.hazardous_waste_category}}</p>
                        <hr>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="4">積替保管区分</th>
                  </tr>
                  <tr>
                    <td colspan="4"><b-form-checkbox disabled :checked="Number(waste.is_transport_and_hold) === 1">積替保管</b-form-checkbox></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">処分場選択</div>
            <div class="table-responsive">
              <table
                class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                  <tr>
                    <th>廃棄物種類</th>
                    <th>委託先事業場</th>
                    <th>処分方法</th>
                    <th>２次委託先事業場</th>
                    <th>処分後廃棄物種類</th>
                    <th>リサイクル有無</th>
                  </tr>
                  <tr v-for="(disposalSite, index) in disposalSitesByWaste" :key="`disposal_site_${index}`">
                    <td>
                      {{disposalSite.disposal_site_by_waste_category.waste_category_of_treatment ? disposalSite.disposal_site_by_waste_category.waste_category_of_treatment.name_abbreviated : ''}}
                    </td>
                    <td>
                      {{disposalSite.disposal_site_by_waste_category.vendor_site_of_treatment ? disposalSite.disposal_site_by_waste_category.vendor_site_of_treatment.name : ''}}
                    </td>
                    <td>
                      {{disposalSite.disposal_site_by_waste_category.zz_treatment_method ? disposalSite.disposal_site_by_waste_category.zz_treatment_method.treatment_method : ''}}
                    </td>
                    <td>
                      {{disposalSite.disposal_site_by_waste_category.vendor_site_after_treatment ? disposalSite.disposal_site_by_waste_category.vendor_site_after_treatment.name : ''}}
                    </td>
                    <td>
                      {{disposalSite.disposal_site_by_waste_category.waste_category_after_treatment ? disposalSite.disposal_site_by_waste_category.waste_category_after_treatment.name_abbreviated : ''}}
                    </td>
                    <td>
                      {{ getRecycle(disposalSite.disposal_site_by_waste_category.is_recycle) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">WDS</div>
            <div class="table-responsive">
              <table
                class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                  <tr>
                    <th>評価の要否</th>
                    <th>排出量</th>
                    <th>単位</th>
                    <th>作業周期</th>
                    <th>荷姿</th>
                    <th>容器返却</th>
                    <th>即出荷</th>
                  </tr>
                  <tr>
                    <td>{{ waste.is_wds_analysis_request ? '必要' : '不要' }}</td>
                    <td>{{ waste.wds_disposal_amount }}</td>
                    <td>{{ waste.zz_jw_unit ? waste.zz_jw_unit.jw_unit : '' }}</td>
                    <td>{{ waste.wds_cycle ? waste.wds_cycle.wds_cycle : '' }}</td>
                    <td>{{ waste.zz_jw_packing_type ? waste.zz_jw_packing_type.jw_packing_type : '' }}</td>
                    <td>{{ waste.is_wds_container_return ? 'あり' : 'なし' }}</td>
                    <td>{{ waste.is_wds_ship_after_treatment ? 'あり' : 'なし' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-blue">含有成分</div>
            <div class="table-responsive">
              <table
                class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                  <tr class="td-bold">
                    <th>含有成分1</th>
                    <th>含有成分1含有量</th>
                    <th>要注意1</th>
                    <th>含有成分2</th>
                    <th>含有成分2含有量</th>
                    <th>要注意2</th>
                    <th>含有成分3</th>
                    <th>含有成分3含有量</th>
                    <th>要注意3</th>
                  </tr>
                  <tr>
                    <td>{{ waste.wds_ingredient_1 }}</td>
                    <td>{{ waste.wds_ingredient_percentage_1 ? waste.wds_ingredient_percentage_1 : '0' }}%</td>
                    <td>{{ waste.is_wds_ingredient_hazardous_1 ? '要注意' : '' }}</td>
                    <td>{{ waste.wds_ingredient_2 }}</td>
                    <td>{{ waste.wds_ingredient_percentage_2 ? waste.wds_ingredient_percentage_2 : '0' }}%</td>
                    <td>{{ waste.is_wds_ingredient_hazardous_2 ? '要注意' : '' }}</td>
                    <td>{{ waste.wds_ingredient_3 }}</td>
                    <td>{{ waste.wds_ingredient_percentage_3 ? waste.wds_ingredient_percentage_3 : '0' }}%</td>
                    <td>{{ waste.is_wds_ingredient_hazardous_3 ? '要注意' : '' }}</td>
                  </tr>
                  <tr class="td-bold">
                    <th colspan="9">その他含有成分および割合％</th>
                  </tr>
                  <tr class="td-bold">
                    <td colspan="9">
                      <p style="white-space: pre;" v-html="waste.wds_ingredient_others"></p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-blue">性質情報</div>
            <div class="table-responsive">
              <table
                class="table table-hover table-borderless align-middle table-centered table-nowrap mb-0 table-striped"
              >
                <tbody>
                  <tr>
                    <th>性状</th>
                    <th>色</th>
                    <th>臭気</th>
                    <th>比重</th>
                    <th>PH</th>
                    <th>引火点</th>
                    <th>粘度</th>
                    <th>水分</th>
                  </tr>
                  <tr>
                    <td>{{waste.wds_property_feature}}</td>
                    <td>{{waste.wds_property_color}}</td>
                    <td>{{waste.wds_property_smell}}</td>
                    <td>{{waste.wds_property_weight}}</td>
                    <td>{{waste.wds_property_ph}}</td>
                    <td>{{waste.wds_property_flash_point}}</td>
                    <td>{{waste.wds_property_viscosity}}</td>
                    <td>{{waste.wds_property_moisture}}</td>
                  </tr>
                  <tr>
                    <th>SDS</th>
                    <th>分析</th>
                    <th>サンプル</th>
                    <th colspan="5">リスクアセスメント</th>
                  </tr>
                  <tr>
                    <td>
                      <div class="d-flex gap-2">
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_risk_assessment" id="is_wds_risk_assessment" value="1" :checked="waste.is_wds_risk_assessment == 1">
                          <label class="form-check-label" for="is_wds_risk_assessment">
                            あり
                          </label>
                        </div>
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_risk_assessment_no" id="is_wds_risk_assessment_no" value="0" :checked="waste.is_wds_risk_assessment == 0">
                          <label class="form-check-label" for="is_wds_risk_assessment_no">
                            なし
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex gap-2">
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_sample" id="is_wds_sample" value="1" :checked="waste.is_wds_sample == 1">
                          <label class="form-check-label" for="is_wds_sample">
                            あり
                          </label>
                        </div>
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_sample_no" id="is_wds_sample_no" value="0" :checked="waste.is_wds_sample == 0">
                          <label class="form-check-label" for="is_wds_sample_no">
                            なし
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex gap-2">
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_analysis_document" id="is_wds_analysis_document" value="1" :checked="waste.is_wds_analysis_document == 1">
                          <label class="form-check-label" for="is_wds_analysis_document">
                            あり
                          </label>
                        </div>
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_analysis_document_no" id="is_wds_analysis_document_no" value="0" :checked="waste.is_wds_analysis_document == 0">
                          <label class="form-check-label" for="is_wds_analysis_document_no">
                            なし
                          </label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex gap-2">
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_sds_document" id="is_wds_sds_document" value="1" :checked="waste.is_wds_sds_document == 1">
                          <label class="form-check-label" for="is_wds_sds_document">
                            あり
                          </label>
                        </div>
                        <div class="form-check">
                          <input disabled class="form-check-input" type="radio" name="is_wds_sds_document_no" id="is_wds_sds_document_no" value="0" :checked="waste.is_wds_sds_document == 0">
                          <label class="form-check-label" for="is_wds_sds_document_no">
                            なし
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="3">有害情報</th>
                    <th colspan="5">発生工程</th>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <p class="white-space-pre">{{waste.wds_hazardous_info}}</p>
                    </td>
                    <td colspan="5">
                      <p class="white-space-pre">{{waste.wds_production_process}}</p>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8">書類種類</th>
                  </tr>
                  <tr>
                    <td colspan="8">
                      <div class="d-flex gap-2">
                          <b-form-checkbox disabled :checked="Number(waste.is_wds_document_wds) === 1">WDS</b-form-checkbox>
                          <b-form-checkbox disabled :checked="Number(waste.is_wds_document_sds) === 1">SDS</b-form-checkbox>
                          <b-form-checkbox disabled :checked="Number(waste.is_wds_document_analysis) === 1">分析データ（含有・溶出）</b-form-checkbox>
                          <b-form-checkbox disabled :checked="Number(waste.is_wds_document_map) === 1">地図</b-form-checkbox>
                          <b-form-checkbox disabled :checked="Number(waste.is_wds_document_others) === 1">その他</b-form-checkbox>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="3">営業希望</th>
                    <th colspan="5">備考</th>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <p class="white-space-pre" v-html="waste.sales_remarks"></p>
                    </td>
                    <td colspan="5">
                      <p class="white-space-pre" v-html="waste.content_remarks"></p>
                    </td>
                  </tr>
                  <tr>
                    <th colspan="8">配車時環境管理部通知要否</th>
                  </tr>
                  <tr>
                    <td colspan="8">{{ waste.is_notify_treatment_group ? '必要' : '不要' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>

        <b-row v-if="isTreatmentGroup">
          <div class="content-block mt-3">
            <div class="title title-bg-green">環境管理部コメント</div>
            <div class="table-responsive">
              <CommonTableComponent>
                <thead class="table-light">
                <tr>
                  <th>コメント</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(comment, index) in commentsByTreatmentGroup" :key="`comments_by_treatment_group_${index}`">
                  <td>{{comment.waste_comments_by_treatment_group}}</td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </div>
          </div>
        </b-row>

        <b-row>
          <div class="content-block mt-3">
            <div class="title title-bg-green">廃棄物見積明細</div>
            <div class="table-responsive">
              <CommonTableComponent>
                <thead class="table-light">
                  <tr>
                    <th>HM管理番号</th>
                    <th>請求書表示用商品名</th>
                    <th>適用開始日</th>
                    <th>適用終了日</th>
                    <th>単価</th>
                    <th>単位</th>
                    <th>原単価</th>
                    <th>受注状況</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(estimate, index) in estimates" :key="`estimate_${index}`">
                    <td>{{estimate.estimate_cd}}</td>
                    <td>{{estimate.invoice_product_name}}</td>
                    <td>{{estimate.start_date_of_application}}</td>
                    <td>{{estimate.end_date_of_application}} {{estimate.end_date_of_application_2}} {{estimate.end_date_of_application_3}}</td>
                    <td class="text-end">{{estimate.unit_price | number}} {{estimate.unit_price_2 | number}} {{estimate.unit_price_3 | number}}</td>
                    <td>{{estimate.zz_unit ? estimate.zz_unit.unit : ''}}</td>
                    <td class="text-end">{{estimate.unit_cost | number}} {{estimate.unit_cost_2 | number}} {{estimate.unit_cost_3 | number}}</td>
                    <td>{{ getActivate(estimate) }}</td>
                  </tr>
                </tbody>
              </CommonTableComponent>
            </div>
          </div>
        </b-row>
      </b-card>
    </b-container>
  </Layout>
</template>
<style scoped lang="scss">
.content-block {
  .title {
    padding: 2px;
    color: #ffffff;
  }
  .title-bg-green {
    background-color: #2cb57e;
  }
  .title-bg-blue {
    background-color: #47bce8;
  }
}
</style>
